(function () {
  'use strict';

  angular
    .module('settings.customization')
    .factory('Customization', Customization);

  Customization.$inject = ['$resource'];

  function Customization($resource) {
    return $resource(
      '/api/',
      {},
      {
        getUnitStatusList: {
          method: 'GET',
          url: 'api/unit/status',
          isArray: true,
        },
        getLeadStatusList: {
          method: 'GET',
          url: 'api/lead/status',
          isArray: true,
        },
        getPriceList: { method: 'GET', url: 'api/price/all', isArray: true },
        getCurrencyList: {
          method: 'GET',
          url: 'api/customization/currency/all',
        },
        getTimezoneList: {
          method: 'GET',
          url: 'api/customization/timezone/all',
        },
        getPlotMeasureList: {
          method: 'GET',
          url: 'api/customization/plot_measure/all',
        },
        getCompany: { method: 'GET', url: 'api/customization/company/get' },
        updateCompany: {
          method: 'POST',
          url: 'api/customization/company/update',
        },
        updateLeadStatusOrder: {
          method: 'POST',
          url: 'api/customization/lead_status/change_order',
        },
        create: {
          method: 'POST',
          url: 'api/customization/create/:custom_type',
        },
        update: {
          method: 'POST',
          url: 'api/customization/update/:custom_type/:id',
        },
        delete: {
          method: 'POST',
          url: 'api/customization/delete/:custom_type/:id',
        },
      },
    );
  }
})();
